export default __webpack_public_path__ + "static/media/DMSans-Regular.9566aaac.woff2";